import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslationHelperService } from "@dtm-frontend/shared/ui/i18n";
import { TranslocoService } from "@jsverse/transloco";
import { UntilDestroy } from "@ngneat/until-destroy";
import { first, map } from "rxjs";
import { DRONE_TOWER_APP_APPLE_STORE_URL, DRONE_TOWER_APP_PLAY_STORE_URL } from "../../../../utils/defaults";

@UntilDestroy()
@Component({
    selector: "dtm-main-page-lib-where-you-can-fly-faq",
    templateUrl: "./where-you-can-fly-faq.component.html",
    styleUrls: ["./where-you-can-fly-faq.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhereYouCanFlyFaqComponent {
    protected readonly translationArguments = {
        droneTowerAppPlayStoreUrl: DRONE_TOWER_APP_PLAY_STORE_URL,
        droneTowerAppAppleStoreUrl: DRONE_TOWER_APP_APPLE_STORE_URL,
    };

    protected readonly questionIndexes$ = this.translationHelperService
        .waitForTranslation("dtmMainPageLib.subpage.whereYouCanFly.faq.title")
        .pipe(
            first(),
            map(() => {
                const translations = this.transloco.getTranslation().get(this.transloco.getActiveLang());
                let faqItemsCount = 0;
                if (translations) {
                    faqItemsCount =
                        Object.keys(translations).filter((key) => key.startsWith("dtmMainPageLib.subpage.whereYouCanFly.faq.questions."))
                            .length / 2;
                }

                return new Array(faqItemsCount).fill(undefined).map((_, index) => index + 1);
            })
        );

    constructor(private readonly transloco: TranslocoService, private readonly translationHelperService: TranslationHelperService) {}
}
